const codeAdmissionCommentTypes = {
  PlanAccion: 1,
  RazonIncumplimiento: 2,
};

export default codeAdmissionCommentTypes;
